import { Endpoint } from '@theia/core/lib/browser/endpoint';
import URI from '@theia/core/lib/common/uri';

export const runtimeUrlForProject = (projectPath: string): string => {
    const runtimeUri: URI = URI.fromFilePath(projectPath).resolve('preview-bin/lved-runtime.js');
    const filesEndpoint: string = new Endpoint({ path: 'files' }).getRestUrl().toString();
    return `${filesEndpoint}?uri=${encodeURIComponent(runtimeUri.toString())}`;
};
